import { Link } from 'react-router-dom';
import { NavbarBrand, NavbarBrandProps } from 'reactstrap';

import { Logo } from '../../../../components/Logo';

export type BrandProps = NavbarBrandProps;

export const Brand: React.FC<BrandProps> = ({ className, ...props }) => (
	<NavbarBrand
		tag={Link}
		to="/"
		className={`header-nav-bar-brand${className ? ` ${className}` : ''}`}
		{...props}
	>
		<Logo />
	</NavbarBrand>
);
